import {THREE} from '../../base/three-defs.js';

// Generates a tiling 3D perlin-worley noise texture on the GPU, used by the
// sky shader to shape and erode the volumetric clouds. Ported from
// SimonDev's Shaders_Clouds1 project; the generator shaders are kept
// verbatim under shaders/clouds/ and are independent of the game's global
// shader includes.

const RESOLUTION = 32;
const SLICES = 64;

export async function generateCloudNoiseTexture(renderer) {
  const loadText = async (url) => {
    const d = await fetch(url);
    return await d.text();
  };

  const header = await loadText('shaders/clouds/header.glsl');
  const oklab = await loadText('shaders/clouds/oklab.glsl');
  const common = await loadText('shaders/clouds/common.glsl');
  const blends = await loadText('shaders/clouds/blend-modes.glsl');
  const noise = await loadText('shaders/clouds/noise.glsl');
  const vsh = await loadText('shaders/clouds/vertex-shader.glsl');
  const fsh = await loadText('shaders/clouds/generator-shader.glsl');

  const material = new THREE.ShaderMaterial({
    uniforms: {
      zLevel: { value: 0.0 },
      numCells: { value: 2.0 },
    },
    vertexShader: vsh,
    fragmentShader: (
        header + '\n' + oklab + '\n' + common + '\n' + blends + '\n' +
        noise + '\n' + fsh),
  });

  const scene = new THREE.Scene();
  const camera = new THREE.OrthographicCamera(0, 1, 1, 0, 0.1, 1000);
  camera.position.set(0, 0, 1);

  const geometry = new THREE.PlaneGeometry(1, 1);
  const plane = new THREE.Mesh(geometry, material);
  plane.position.set(0.5, 0.5, 0);
  scene.add(plane);

  const rt = new THREE.WebGLRenderTarget(RESOLUTION, RESOLUTION);
  const data = new Uint8Array(SLICES * 4 * RESOLUTION * RESOLUTION);

  const previousTarget = renderer.getRenderTarget();
  for (let i = 0; i < SLICES; i++) {
    material.uniforms.zLevel.value = i / 4.0;

    renderer.setRenderTarget(rt);
    renderer.render(scene, camera);

    const pixelBuffer = new Uint8Array(RESOLUTION * RESOLUTION * 4);
    renderer.readRenderTargetPixels(rt, 0, 0, RESOLUTION, RESOLUTION, pixelBuffer);
    data.set(pixelBuffer, i * (4 * RESOLUTION * RESOLUTION));
  }
  renderer.setRenderTarget(previousTarget);

  rt.dispose();
  geometry.dispose();
  material.dispose();

  const texture = new THREE.Data3DTexture(data, RESOLUTION, RESOLUTION, SLICES);
  texture.format = THREE.RGBAFormat;
  texture.type = THREE.UnsignedByteType;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.wrapR = THREE.RepeatWrapping;
  texture.generateMipmaps = true;
  texture.needsUpdate = true;

  return texture;
}
